import { useEffect, useState } from 'react';
import { adminApi, type AuditLogRow } from '@/admin/adminApi';

export function AdminAuditPage() {
  const [rows, setRows] = useState<AuditLogRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.getAuditLog().then((res) => {
      if (res.success) setRows(res.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="max-w-4xl space-y-4">
      <div>
        <h2 className="text-lg font-semibold text-ink">Audit trail</h2>
        <p className="mt-1 text-sm text-muted">
          Every admin write action and migration-time decision, most recent first.
        </p>
      </div>

      {loading ? (
        <p className="text-sm text-muted">Loading…</p>
      ) : (
        <div className="overflow-x-auto rounded-2xl border border-stone-200">
          <table className="w-full text-left text-sm">
            <thead className="bg-stone-50 text-xs uppercase text-muted">
              <tr>
                <th className="px-3 py-2">Time</th>
                <th className="px-3 py-2">Action</th>
                <th className="px-3 py-2">Entity</th>
                <th className="px-3 py-2">User</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {rows.map((r) => (
                <tr key={r.id}>
                  <td className="px-3 py-2 whitespace-nowrap text-muted">{r.timestamp}</td>
                  <td className="px-3 py-2">
                    <span className="rounded-full bg-brand/10 px-2 py-0.5 text-xs font-medium text-brand">
                      {r.action}
                    </span>
                  </td>
                  <td className="px-3 py-2 font-mono text-xs text-ink/80">
                    {r.entity_type}
                    {r.entity_id ? `:${r.entity_id}` : ''}
                  </td>
                  <td className="px-3 py-2 text-muted">{r.user_id ?? 'system'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
